export const AIRA_CONFIG: any = {
  textLabels: {
    headerTitle: 'Aira',
    headerDesc: 'AI Care Assistant',
    welcomeText: {
      heading: 'Hey 👋  I’m Aira.',
      title: 'I can explain your policy coverage and help with support.',
      predefinedPrompt: [
        { title: 'What Am I Covered For?', icon: '' },
        { title: 'Get Support Instantly', icon: '' },
      ],
    },
  },
  theme: {
    windowHeight: '550px',
    windowMaxHeight: '550px',
    markdownFontSize: '14px',
    markdownLineHeight: '1.5',
    markdownColor: '#fff',
    markdownH1FontSize: '20px',
    markdownH2FontSize: '18px',
    markdownH3FontSize: '16px',
    markdownH4FontSize: '14px',
    markdownH5FontSize: '12px',
    markdownH6FontSize: '10px',
    markdownCodeFontSize: '12px',
  },
  assets: {
    icons: {
      newChat: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill="white"/></svg>`,
      chatToggle:
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 10H16M8 14H12M21 12C21 16.9706 16.9706 21 12 21C10.5124 21 9.10904 20.6391 7.87532 20L3 21L4 16.1247C3.36093 14.891 3 13.4876 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      close: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6l12 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    },
  },
};
